import React, { useEffect, useState } from 'react';
import InvoicesService from '../Services/InvoicesService';
import LocalService from '../Services/LocalService';
import { useToasts } from 'react-toast-notifications';
import AuthService from '../Services/AuthService';
import { Row, Col, Button, Input, Card, CardBody, FormGroup, Label, Table} from 'reactstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTranslation, t } from 'react-multi-lang';
//import { , Tr, Td, Thead, Tbody, Th } from 'react-super-responsive-table';
import {
    faRefresh
} from "@fortawesome/free-solid-svg-icons";
import VolumesService from '../Services/VolumesService';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { DionysosService } from '../Services/DionysosService';


const AllVolumes = ({t}) => {
    const [config, setConfig] = useState({});
    const [volumes, setVolumes] = useState([]);
    const [search, setSearch] = useState('');
    const [filterDateFrom, setFilterDateFrom] = useState(null);
    const [filterDateTo, setFilterDateTo] = useState(null);
    const [selves, setSelves] = useState([]);
    const [self, setSelf] = useState('');

    const authService = new AuthService();
    const volumesService = config.whCode === '219' ? new DionysosService() : new VolumesService();
    const { addToast } = useToasts();

    useEffect(() => {
        setConfig(authService.getConfig());
        setSelves(authService.getConfig().shelves);
        getStock();
    }, []);

    const getStock = () => {
        volumesService.getAllVolumes(self, filterDateFrom, filterDateTo).then(r => setVolumes(r.data)).catch(e => addToast(t('stock.errorGettingStock'), {type: 'error'}));
    };

    return  <Card style={{padding: '20px'}}>
            <CardBody>
                <h3>{t('sideBar.allVolumes')}</h3>
                <Row>
                    <Col md="4">
                        <FormGroup>
                            <Label>{t('search')}</Label>
                            <Input type="search" onChange={e => setSearch(e.target.value)} placeholder="Search"/>
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <Label>{t('from')}</Label>
                        <Input size="sm" type="date" placeholder={t('from')} onChange={(e) => setFilterDateFrom(e.target.valueAsDate)} />
                    </Col>
                    <Col md="2">
                        <Label>{t('to')}</Label>
                        <Input size="sm" type="date" placeholder={t('to')} onChange={(e) => setFilterDateTo(e.target.valueAsDate)} />
                    </Col>
                    <Col md="2">
                        <Label>{t('volumes.self')}</Label>
                        <Input size="sm" type="select" placeholder={t('volumes.quarryLevel')} onChange={(e) => setSelf(e.target.value)}>
                            <option value="">{t('volumes.quarryLevel')}</option>
                            {
                                selves && selves.map(s => <option key={s} value={s}>{s}</option>)
                            }
                        </Input>
                    </Col>
                    <Col md="1">
                        <Label>Excel</Label><br />
                        <ReactHTMLTableToExcel
                            id="unassessedButton"
                            className="btn btn-sm btn-success btn-block"
                            table="stockTable"
                            filename="stock"
                            sheet="volumes"
                            buttonText="Excel" style={{width: '100%'}}/>
                    </Col>
                    <Col md="1" >
                        <br />
                        <Button color="primary" size="sm" block onClick={getStock}><FontAwesomeIcon icon={faRefresh} /></Button>
                    </Col>
                </Row>
                
                <Table responsive id="stockTable">
                    <thead>
                        <tr>
                            <th width="10%">{t('volumes.sn')}</th>
                            <th width="10%">{t('volumes.quarryLevel')}</th>
                            <th width="10%">{t('volumes.date')}</th>
                            <th width="10%">{t('volumes.dimensions')} - {t('volumes.dimensionBreakdown')}</th>
                            <th width="40%">{t('volumes.item')}</th>
                            <th width="5%">{t('volumes.wh')}</th>
                            <th width="5%">{t('volumes.assessment')}</th>
                            <th width="10%">{t('volumes.weight')}</th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        volumes.filter((v) => !v.underReAssessment)
                        .filter(v => v.erpNumber?.includes(search) || v.lot?.includes(search) 
                        || v.self?.includes(search)
                        || volumesService.getVolumeItem(v)?.includes(search)
                        || v.assessments?.[0]?.assessment?.includes(search) || (v.date.split('T')[0].split('-').reverse()[0] + ' - ' + v.dayNumber).includes(search) )
                        .sort((v1, v2) => v1.date > v2.date ? 1 : -1).map(v => {
                            return <tr key={v.volumeId} style={{borderBottom: '1px solid #aaa'}}>
                                <td >{v.date.split('T')[0].split('-').reverse()[0]} - {v.dayNumber}</td>
                                <td >{v.self}</td>
                                <td >{v.date.split('T')[0].split('-').reverse().join('-')}</td>
                                <td >{ v.measurement && v.measurement.length + '/' + v.measurement.width + '/' + v.measurement.depth}{
                                    v.wh === '219' && <span> ({v.measurement?.outerLength} / {v.measurement?.outerWidth} / {v.measurement?.outerDepth})</span>
                                    }</td>
                                <td >
                                    {volumesService.getVolumeItem(v)} - {volumesService.getVolumeDescr(v)} {" - "}
                                    {t('volumes.volumeNumber')}: <span className="text-primary" style={{fontSize: '21px', fontWeight: 'bold'}}>{v.erpNumber}</span> {" - "}
                                    {t('volumes.lotNumber')}: {v.lot}
                                </td>
                                <td >
                                    {v.wh}
                                </td>
                                <td >
                                    {v.assessments && v.assessments.length > 0 ? v.assessments[0].assessment : ''}
                                </td>
                                <td >
                                    <span style={{fontSize: '20px'}} className="text-primary">{v.weight.toLocaleString()}kg</span>
                                </td>
                            </tr>
                        })
                    }
                    </tbody>
                </Table>
        </CardBody>
    </Card>
};

export default withTranslation(AllVolumes);